<form [formGroup]="uploadDocumentForm" (submit)="onSubmit()">
    <div class=" space-y-6">
      <div class="divide-y divide-gray-200 bg-white ">
        <div class="grid grid-cols-3 gap-6 divide-x divide-gray-200">
          <div class="col-span-1 px-4 py-5">
            <h3
              class="text-lg font-medium leading-6 text-primary-accessible-green"
            >
              Upload a new file
            </h3>
            <p class="mt-2 text-sm text-gray-500">
               The file type must be one of the following:
               <li class="font-semibold" *ngFor="let type of allowed_file_types">{{type}}</li>
               
               <br>
               Maximum file size is <span class="font-semibold">{{MaximumFileSizeInMB}}mb</span>
            </p>
          </div>
  
          <div class=" col-span-2 px-4 py-5 text-sm" >
            
              <mat-form-field class="w-full">
                <mat-label>File Related Name</mat-label>
                <input
                  matInput
                  type="text"
                  placeholder="Enter a related name for this file"
                  formControlName="related_name"
                />
              </mat-form-field>
              <mat-form-field class="w-full">
                <mat-label>Category</mat-label>
                <mat-select formControlName="category">
                  <mat-option *ngFor="let category of documentCategories  | keyvalue " [value]="category.value">{{
                    category.value
                  }}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="w-full">
                <mat-label>Description of the Document</mat-label>
                <textarea
								matInput
                name="text" 
                rows="2"
                placeholder="Describe the document"
                formControlName="description"
                ></textarea>
              </mat-form-field>
            <input 
            formControlName="file"
            id="file" 
            type="file" 
            [accept]="allowed_file_extensions_html_view"
            class="form-control"
            (change)="onFileChange($event)" />
          </div>
        </div>
    
      </div>


      <div class="px-4" *ngIf="fileBeingUploaded">
        <div class="flex items-center space-x-1">
          <svg aria-hidden="true" class="w-5 h-5 mr-1 text-gray-200 animate-spin dark:text-gray-600 fill-green-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
              <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
          </svg>                
          <span class="block"> Uploading {{uploadedFile?.name}} ... </span>
        </div>
    </div > 


    <div class="px-4 text-red-700 bg-red-50 p-2" *ngIf="fileFailedToUpload" >
      <div class="flex items-center space-x-1"> 
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
        </svg>
        <span class="block"> Document could not be uploaded, please try again. </span>
      </div>
  </div > 
  
      <div
        class="sticky bottom-0 z-10 flex justify-end gap-3 bg-gray-400/25 p-4 shadow backdrop-blur-sm"
      >
      <app-button-cancel
      (click)="close()"    >
      Cancel
    </app-button-cancel>

        <app-button-primary            type="submit"
        [disabled]=" uploadDocumentForm.invalid || fileBeingUploaded || !validFileExtension">
          Upload file
        </app-button-primary>
      </div>
    </div>
  </form>